import { useEffect } from "react";
import { BLITZ_CI_AUTH } from "../../utils/constants";
import { useNavigate } from "react-router-dom";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem(BLITZ_CI_AUTH);
    navigate("/login");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (<div>Hello World!</div>);
}

export default Logout;
